module.exports = __webpack_public_path__ + "img/partners-divider.dcd0478a.jpg";